// extracted by mini-css-extract-plugin
export default {"wrapRenderStep":"AddBackground_wrapRenderStep__Z895y","wrapImage":"AddBackground_wrapImage__riZbB"};